import React from 'react';
import logo from '../logos/Logo-hw-tran.png';
import './Footer.css';
import phoneIcon from '../logos/phone.png';
import location from '../logos/location.png';
import bluephone from '../logos/phone-blue.png';
import mail from '../logos/mail.png'

const Footer = () => {
  return (
    <footer className="footer">
      {/* Phone Number Section */}
      <div className="footer-phone" style={{ display: 'flex', alignItems: 'center', fontWeight: '500' }}>
        <img src={phoneIcon} alt="Phone Icon" className="phone-icon" style={{ marginRight: '10px' }} />
        <p>+1 (888) 780-3912</p>
      </div>
      <div className="footer-phone-line"></div>

      <div className="footer-container">
        {/* Left Section */}
        <div className="footer-left">
          <img src={logo} alt="Top Tier Benefits Logo" className="footer-logo" />
        </div>

        {/* Center Section */}
        <div className="footer-center">
          <div className="footer-links">
            <h3>Our Links</h3>
            <ul>
              <li><a href="/about">About Us</a></li>
              <li><a href="/how-it-works">How It Works</a></li>
              <li><a href="/contact">Contact Us</a></li>
              <li><a href="/privacy-policy">Privacy Policy</a></li>
            </ul>
          </div>
        </div>
        <div className="footer-right-center">
          <div className="footer-hours">
            <h3>Opening Hours (CST)</h3>
            <ul>
              <li>Mon 8:00am - 6:00pm</li>
              <li>Tue 8:00am - 6:00pm</li>
              <li>Wed 8:00am - 6:00pm</li>
              <li>Thu 8:00am - 6:00pm</li>
              <li>Fri 8:00am - 6:00pm</li>
              <li>Sat Closed</li>
              <li>Sun Closed</li>
            </ul>
          </div>
        </div>

        {/* Right Section */}
        <div className="footer-right">
          <h3>Get In Touch</h3>
          <ul>
            <li style={{ display: 'flex', alignItems: 'center', marginBottom: '10px' }}>
              <img src={location} alt="Location Icon" className="location-icon" style={{ marginRight: '10px' }} />
              205-1555 St. James Street, Winnipeg, MB, Canada, R3H 1B5
            </li>
            <li style={{ display: 'flex', alignItems: 'center', marginBottom: '10px' }}>
              <img src={bluephone} alt="Blue Phone Icon" className="bluephone-icon" style={{ marginRight: '10px' }} /> 
              +1 (888) 780-3912
            </li>
            <li style={{ display: 'flex', alignItems: 'center', marginBottom: '10px' }}>
              <img src={mail} alt="Mail Icon" className="mail-icon" style={{ marginRight: '10px' }} /> 
              <a href="mailto:supportusa@toptierbenefits.com">support@toptierbenefits.com</a>
            </li>
          </ul>
        </div>
      </div>

      {/* Bottom Bar */}
      <div className="footer-bottom">
        <p>© 2024 Top Tier Benefits. All Rights Reserved.</p>
        <div className="footer-privacy">
          {/*<a href="/privacy-policy">Privacy Policy</a>*/}
          <a href="/termsandconditions">Terms and Conditions</a>
        </div>
      </div>
    </footer>
  );
};

export default Footer;